module.exports = __webpack_public_path__ + "img/eclient@3x.5ecf8779.png";